/* eslint-disable no-use-before-define */
import React, { useContext, useEffect, useState } from 'react';
import FormItem from 'antd/es/form/FormItem';
import {
  Layout,
  Form,
  Input,
  Button,
  Checkbox,
  Card,
  Image,
  Space,
  InputNumber,
  message,
  Col,
  Row,
} from 'antd';
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  signInWithCredential,
  linkWithPopup,
  GoogleAuthProvider,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  linkWithPhoneNumber,
} from 'firebase/auth';
import { useNavigate, useLocation } from 'react-router-dom';
import { addUser } from './api';
import { addMessagingTokenToUser } from './utils';
import { StoreContext } from '../store/index';
import { auth, fcmToken } from '../firebase';
import logo from '../resources/google.png';
import { ROLES, LANGUAGES, POSITION } from '../constants';
import './index.css';
import News from '../news/index';

const Login = () => {
  const store = useContext(StoreContext);
  const {
    user: [user, setUser],
  } = store;
  const { Header, Content, Footer, Sider } = Layout;
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const location = useLocation();

  const [loggedMail, setLoggedMail] = useState();
  const [loading, setLoading] = useState(false);
  const [showOTP, setShowOTP] = useState(false);

  const showPopup = () => {
    signInWithPopup(auth, new GoogleAuthProvider())
      .then(result => {
        // This gives you a Google Access Token. You can use it to access the Google API.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        const token = credential.accessToken;
        // The signed-in user info.
        if (result.user.phoneNumber) {
          setUser(result.user);
          navigate(location.search !== '' ? `/shifts/${location.search}` : '/');

          // Get registration token. Initially this makes a network call, once retrieved
          // subsequent calls to getToken will return from cache.
          addMessagingTokenToUser(fcmToken, result.user.uid);
        } else {
          setLoggedMail(result.user);
        }
      })
      .catch(error => {
        // Handle Errors here.
        const errorCode = error.code;
        const errorMessage = error.message;
        // The email of the user's account used.
        const { email } = error;
      });
  };

  const onCaptchVerify = () => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        'recaptcha-container',
        {
          size: 'invisible',
          'expired-callback': () => {},
        },
        auth,
      );
    }
  };

  const onSignup = () => {
    setLoading(true);
    onCaptchVerify();
    const appVerifier = window.recaptchaVerifier;
    const phoneNumber = form.getFieldsValue().phone;
    if (!Number.isNaN(phoneNumber)) {
      linkWithPhoneNumber(auth.currentUser, `+${phoneNumber}`, appVerifier)
        .then(confirmationResult => {
          window.confirmationResult = confirmationResult;
          setLoading(false);
          setShowOTP(true);
          message.success('Codigo enviado');
        })
        .catch(error => {
          message.error('Numero invalido');
          setLoading(false);
        });
    }
  };

  const getDefaultLanguage = () => {
    if (navigator.language.includes('es')) {
      return LANGUAGES.SPANISH;
    }
    if (navigator.language.includes('ar')) {
      return LANGUAGES.ARABIC;
    }
    return LANGUAGES.ENGLISH;
  };

  const onOTPVerify = async () => {
    setLoading(true);
    window.confirmationResult
      .confirm(form.getFieldsValue().otp)
      .then(async res => {
        setLoading(false);
        const u = { ...res.user, photoURL: res.user.providerData[0].photoURL };
        setUser(u);
        addUser(
          {
            email: u.email,
            age: 0,
            nickname: u.displayName,
            position: POSITION.DEFENCE,
            level: 'Basico',
            uid: u.uid,
            friendsIds: [],
            photoURL: u.photoURL,
            role: ROLES.USER,
            languageSelected: getDefaultLanguage(),
            tokens: 0,
          },
          setLoading,
        );
        addMessagingTokenToUser(fcmToken, u);
        navigate(location.search !== '' ? `/shifts/${location.search}` : '/');
      })
      .catch(err => {
        message.error('Codigo invalido');
        setLoading(false);
      });
  };

  const onCancel = () => {
    setShowOTP(false);
    form.setFieldsValue({
      phone: null,
    });
  };

  const validate = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      setLoading(false);
      return values;
    } catch (errorInfo) {
      setLoading(false);
      return null;
    }
  };

  const sendCode = async () => {
    const values = await validate();
    if (values) {
      onSignup();
    }
  };

  return (
    <Layout>
      <Content style={{ margin: '50px' }}>
        {loggedMail ? (
          <Form name="basic" form={form} onFinish={sendCode}>
            {showOTP ? (
              <Card>
                <Col>
                  <Row align="middle" justify="center">
                    <FormItem
                      name="otp"
                      label="Codigo"
                      rules={[
                        {
                          required: true,
                          message: 'Ingrese el codigo obtenido via SMS.',
                        },
                        () => ({
                          validator(_, value) {
                            if (!value) {
                              return Promise.reject(Error(''));
                            }
                            if (Number.isNaN(value)) {
                              return Promise.reject(Error('Ingresar numeros.'));
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}>
                      <Input.OTP
                        style={{ width: '100%' }}
                        placeholder="123456"
                        controls={false}
                        onChange={value =>
                          form.setFieldsValue({
                            otp: value,
                          })
                        }
                      />
                    </FormItem>
                  </Row>
                  <Row
                    justify="center"
                    align="middle"
                    style={{
                      marginTop: '20px',
                    }}>
                    <Col xs={24}>
                      <Button
                        style={{
                          width: '100%',
                          marginTop: '4px',
                          height: 'auto',
                          padding: '4px 4px',
                        }}
                        type="primary"
                        onClick={onOTPVerify}
                        size="small"
                        loading={loading}>
                        Verificar Codigo
                      </Button>
                    </Col>
                    <Col xs={24}>
                      <Button
                        style={{
                          width: '100%',
                          marginTop: '4px',
                          height: 'auto',
                          padding: '4px 4px',
                        }}
                        type="primary"
                        ghost
                        onClick={sendCode}
                        size="small"
                        loading={loading}>
                        Reenviar Codigo
                      </Button>
                    </Col>
                    <Col xs={24}>
                      <Button
                        danger
                        style={{
                          width: '100%',
                          marginTop: '4px',
                          height: 'auto',
                          padding: '4px 4px',
                        }}
                        onClick={onCancel}
                        size="small"
                        loading={loading}>
                        Cancelar
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Card>
            ) : (
              <Card>
                <Col>
                  <Row align="middle">
                    <FormItem
                      name="phone"
                      label="Telefono"
                      rules={[
                        {
                          required: true,
                          message: 'Ingrese un numero de telefono.',
                        },
                        () => ({
                          validator(_, value) {
                            if (!value) {
                              return Promise.reject(Error(''));
                            }
                            if (Number.isNaN(value)) {
                              return Promise.reject(Error('Ingresar numeros.'));
                            }
                            if (value.toString().length < 9) {
                              return Promise.reject(
                                Error(
                                  'El telefono debe tener al menos 9 digitos',
                                ),
                              );
                            }
                            return Promise.resolve();
                          },
                        }),
                      ]}>
                      <Space.Compact>
                        <InputNumber
                          style={{ width: '100%' }}
                          addonBefore="+"
                          placeholder="Telefono"
                          controls={false}
                          onChange={value =>
                            form.setFieldsValue({
                              phone: value,
                            })
                          }
                        />
                      </Space.Compact>
                    </FormItem>
                  </Row>
                  <Row
                    justify="center"
                    align="middle"
                    style={{ marginTop: '24px' }}>
                    <Button
                      style={{
                        width: '100%',
                        height: '100%',
                        padding: '4px 4px',
                      }}
                      type="primary"
                      onClick={sendCode}
                      loading={loading}
                      size="small">
                      Enviar Codigo
                    </Button>
                  </Row>
                </Col>
              </Card>
            )}
          </Form>
        ) : (
          <>
            <News />

            <Button
              style={{
                height: 'auto',
                width: '100%',
                marginTop: '8px',
                textAlign: 'center',
                display: 'flow',
              }}
              icon={
                <Row justify="start">
                  <Image
                    className="icon"
                    preview={false}
                    src={logo}
                    alt="logo"
                  />
                </Row>
              }
              type="primary"
              loading={loading}
              onClick={() => showPopup()}>
              Ingresar Con Google
            </Button>
          </>
        )}
      </Content>
    </Layout>
  );
};
export default Login;
